import ReactDocViewer from "@cyntler/react-doc-viewer";
import { DocViewerRenderers } from "./DocViewerRenderers";

export const DocViewer = ({ documentUri }: { documentUri: string }) => {
  if (!documentUri) {
    return (
      <div className="p-4 text-center">
        <p>No Attachment</p>
      </div>
    );
  }

  return (
    <ReactDocViewer
      prefetchMethod="GET"
      pluginRenderers={DocViewerRenderers}
      documents={[{ uri: documentUri }]}
      config={{
        header: {
          disableHeader: true,
        },
        noRenderer: {
          overrideComponent: ({ document, fileName }) => {
            const fileText = fileName || document?.fileType || "";
            console.log(document);
            return (
              <div className="p-4 text-center truncate">
                Failed to load preview
                {fileText && (
                  <>
                    {" "}
                    for
                    <br />
                    {fileText}
                  </>
                )}
              </div>
            );
          },
        },
        loadingRenderer: {
          overrideComponent: ({ document, fileName }) => {
            const fileText = fileName || document?.fileType || "";
            return (
              <div className="p-4 text-center truncate">
                Loading
                {fileText && (
                  <>
                    <br />({fileText})
                  </>
                )}
              </div>
            );
          },
        },
        csvDelimiter: ",",
        pdfZoom: {
          defaultZoom: 1.0,
          zoomJump: 0.2,
        },
        pdfVerticalScrollByDefault: true,
      }}
    />
  );
};
